<template>
  <uikit-input-new v-bind="$attrs" id="email" name="email" placeholder="Votre adresse email" />
  <uikit-button
    v-bind="$attrs"
    class="u-w-full"
    type="primary"
    :loading="isSubmitting"
    :disabled="isSubmitting"
    @click="handleSubmitForm"
  >
    Être recontacté(e) par l’agence
  </uikit-button>
</template>

<script setup>
import { UikitButton, UikitInputNew } from '@hz/ui-kit'

import { useForm } from 'vee-validate'

const config = useRuntimeConfig()

const props = defineProps({
  onSuccess: {
    type: Function,
    required: true,
  },
  handleSubmitContactForm: {
    type: Function,
    required: true,
  },
})

const validationSchema = {
  email: { email: true, required: true },
}

const { handleSubmit, isSubmitting } = useForm({
  validationSchema,
})

const handleSubmitForm = handleSubmit(async (values) => {
  grecaptcha.enterprise.ready(async () => {
    const token = await grecaptcha.enterprise.execute(config.public.adReCaptchaSiteKey, { action: 'LOGIN' })
    props.handleSubmitContactForm({
      reCaptchaToken: token,
      email: values.email,
    })

    props.onSuccess()
  })
})
</script>
